/** Conteúdo do tutorial: breadcrumb, título, vídeo do YouTube (ou placeholder)
 *  e o HTML do conteúdo (via dangerouslySetInnerHTML — a tipografia dark mora
 *  na classe .tutorial-content do shell). */
import { tutorials } from '../data';
import { categoryOf } from '../search';

export function ArticleView({ tutorialKey }: { tutorialKey: string }) {
  const tut = tutorials[tutorialKey];
  const cat = categoryOf(tutorialKey);
  if (!tut) {
    return (
      <div className="bg-white border border-gray-200 rounded-2xl p-8 text-center text-slate-400 shadow-sm">
        Tutorial não encontrado.
      </div>
    );
  }

  return (
    <article className="bg-white border border-gray-200 rounded-2xl p-5 sm:p-8 shadow-sm">
      {/* Breadcrumb */}
      {cat ? (
        <div className="text-[11px] font-bold text-indigo-500 uppercase tracking-wider mb-3 flex items-center gap-1.5">
          <i className={cat.homeIcon} /> {cat.title}
        </div>
      ) : null}

      <h1 className="text-2xl sm:text-3xl font-black text-slate-900 tracking-tight mb-5 leading-tight">{tut.title}</h1>

      {/* Vídeo — moldura clara com leve gradiente pra separar do fundo escuro do player */}
      {tut.video ? (
        <div className="mb-6 rounded-xl overflow-hidden border border-gray-200 shadow-sm bg-gray-900 ring-1 ring-gray-200">
          <iframe
            src={tut.video}
            title={tut.title}
            className="w-full h-[250px] md:h-[440px] block"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      ) : (
        <div className="mb-6 rounded-xl border border-dashed border-gray-300 bg-gray-50 p-6 text-center text-slate-400">
          <i className="fas fa-video-slash text-2xl mb-2 block" />
          Vídeo em produção — confira o passo a passo abaixo.
        </div>
      )}

      {/* Conteúdo (HTML do tutorial) */}
      <div className="tutorial-content max-w-3xl" dangerouslySetInnerHTML={{ __html: tut.content }} />

      {tut.faq && tut.faq.length > 0 ? (
        <section className="max-w-3xl mt-10 pt-8 border-t border-gray-200">
          <h2 className="text-xl font-black text-slate-900 mb-4">Perguntas frequentes</h2>
          <div className="space-y-3">
            {tut.faq.map((f) => (
              <details key={f.pergunta} className="group rounded-xl border border-gray-200 bg-gray-50 px-4 py-3">
                <summary className="cursor-pointer font-bold text-slate-800 list-none flex items-start gap-2">
                  <i className="fas fa-circle-question text-indigo-500 mt-1" />
                  <span>{f.pergunta}</span>
                </summary>
                <p className="mt-2 text-slate-600 leading-relaxed">{f.resposta}</p>
              </details>
            ))}
          </div>
        </section>
      ) : null}
    </article>
  );
}
